<template>
  <div class="col-xs-12 col-sm-6 col-lg-3">
    <div class="form-group">
      <div class="custom-dropdown">
        <button class="form-control dropdown-toggle text-left country" type="button" id="country" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
          Country <i class="icon icon-arrow-down-custom icon-right"></i>
        </button>
        <div class="dropdown-menu" aria-labelledby="country">
          <ul>
            <li v-for="country in countries">
              <span class="custom-control custom-checkbox rtl">
                <input
                    type="checkbox"
                    name="country[]"
                    class="custom-control-input"
                    :id="country.name"
                    :checked="countrySelected(country)"
                    v-on:click="toggleSearch(country)"
                  >
                  <label class="custom-control-label" :for="country.name">
                    {{ country.name }}
                    <sup class="text-primary lead help">
                      <!-- <strong
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Nulla non ipsum in enim condimentum viverra nec ac sem. Suspendisse convallis molestie nulla in consectetur. In porttitor risus id risus congue, nec accumsan urna pharetra.">
                          ?
                      </strong> -->
                    </sup>
                  </label>
                </input>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "country-dropdown",
  props: ['type'],
  computed: {
    ...mapGetters({
      results: "results",
      countries: "devCountries",
      capitalTypeSelected: 'capitalTypeSelected',
      providerTypeSelected: 'providerTypeSelected',
      countrySelected: 'countrySelected',
      sectorSelected: 'sectorSelected'
    })
  },
  methods: {
    ...mapMutations([
      'toggleSectorsParam',
      'toggleCapitalTypesParam',
      'toggleProviderTypesParam',
      'toggleCountriesParam'
    ]),
    ...mapActions(['search']),
    toggleSearch(value){
      this.toggleCountriesParam(value)
      this.$emit('user-select')
      $('.dropdown-menu').click(function(e) {
        e.stopPropagation();
      });
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/elements/SearchBars/dropdowns/CountryDropDown.vue